export const VERSION_CLIENT = process.env.VERSION || '';
